module.exports = __webpack_public_path__ + "static/media/Hurdle.3913e1a5.svg";